/**
 * Whether full-screen images of a property carry the "amber" watermark (P1D-5542).
 *
 * Supply turns it off per property in the CRM (`meta.is_watermark_disabled`). Anything other
 * than an explicit `true` keeps today's behaviour, so a missing or malformed value never
 * removes the watermark. Pass the root (property) inventory's `meta`.
 */
const isWatermarkEnabled = (meta?: { is_watermark_disabled?: unknown } | null): boolean =>
  meta?.is_watermark_disabled !== true;

export default isWatermarkEnabled;
